import { setRequestHeaders } from 'middle-domain';
import { SSO } from '@vhcl/saas-login';
class TidCenter {
  constructor() {
    this.isLogin = false; //是否是登陆状态
    this.isWhiteList = false; //是否是白名单成员
    this.expiredTime = 1000 * 60 * 60 * 24 * 7; //7天过期
  }

  async setTid(tid, webinarId, source, subjectId) {
    // source: 1游客，2报名表单，3登陆，4白名单
    // webinarId:活动id
    // subjectid:专题id
    switch (source) {
      case 1:
      case 2:
        if (!this.isLogin && !this.isWhiteList) {
          return this._saveTid(tid, webinarId, subjectId, true);
        }
        break;
      case 3:
        this.isLogin = true;
        if (!this.isWhiteList) {
          this._saveTid(tid, webinarId, subjectId, true);
        }
        break;
      case 4:
        this.isWhiteList = true;
        return this._saveTid(tid, webinarId, subjectId);
    }
  }

  getTid(webinarId, subjectId) {
    const key = this._getTidStorageKey(webinarId, subjectId);
    console.log('key:', key);
    return SSO.instance.getLocalStorage(key);
  }

  _saveTid(tid, webinarId, subjectId, sync) {
    const key = this._getTidStorageKey(webinarId, subjectId);
    // 设置到请求头
    setRequestHeaders({
      'token-Id': tid
    });
    //报名或登录的时候需要存储user_id（此时的tid为user_id）
    if (sync) {
      const businessId = sessionStorage.getItem('initGrayId');
      SSO.instance.setLocalStorage(
        `${businessId}_user_id`,
        tid,
        new Date().getTime() + this.expiredTime
      );
    }

    return SSO.instance.setLocalStorage(key, tid, new Date().getTime() + this.expiredTime);
  }

  _getTidStorageKey(webinarId, subjectId) {
    const businessId = sessionStorage.getItem('initGrayId');
    return subjectId ? `${businessId}_${subjectId}_s_tid` : `${businessId}_${webinarId}_tid`;
  }
}

export default new TidCenter();
